import API from '../../API.redux';
import { endpoints } from '../../../config/endpoints';
import { joinUrlWithRequiredParams } from '../../../utils';

export const getEndpoint = (which) => endpoints.respondents.applications_questionnaires[which];

export const statusByToken = ({
  apiArgs = {},
  params,
  applicationQuestionnaireToken,
  link_type,
} = {}) => {
  const ENDPOINT = getEndpoint('status');

  return API(apiArgs)({
    url: joinUrlWithRequiredParams({
      params,
      url: ENDPOINT.url,
      requiredParamsValues: {
        token: applicationQuestionnaireToken,
        link_type,
      },
    }),
    method: ENDPOINT.method,
  });
};
